"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVehicles = getVehicles;
exports.setVehicleYear = setVehicleYear;
exports.setVehicleGroup = setVehicleGroup;
exports.setVehicleModel = setVehicleModel;
exports.setVehicleId = setVehicleId;
exports.setIndustryType = setIndustryType;
exports.setVehicleBrand = setVehicleBrand;
exports.setVehicleProductType = setVehicleProductType;
exports.setVehicleProductSubtype = setVehicleProductSubtype;
exports.setVehicleProgram = setVehicleProgram;
exports.setFilter = setFilter;

var _ = require("./");

var _ContentDelivery = _interopRequireDefault(require("../services/ContentDelivery"));

var _axios = require("axios");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Load all available vehicles (model + year)
 *
 * @returns {Promise} on vehicles API request
 */
function getVehicles() {
  return function (dispatch) {
    dispatch({
      type: _.GET_VEHICLES_REQUEST
    });
    return _ContentDelivery["default"].getVehicles().then(function (res) {
      dispatch({
        type: _.GET_VEHICLES_SUCCESS,
        payload: res.data
      });
    })["catch"](function (error) {
      if ((0, _axios.isCancel)(error)) {
        dispatch({
          type: _.GET_VEHICLES_CANCEL
        });
      } else {
        dispatch({
          type: _.GET_VEHICLES_ERROR,
          payload: error
        });
      }
    });
  };
}
/**
 * Sets vehicle year
 *
 * @deprecated use setVehicleProgram() to set the vehicle year, use local state to set the currently selected year
 *
 * @param {string} year
 * @returns {function(*)}
 */


function setVehicleYear(year) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_VEHICLE_YEAR,
      payload: year
    });
  };
}
/**
 * Updates selected vehicle group
 *
 * @deprecated use local state to store the vehicle group information
 *
 * @param {string} group
 * @returns {{type, payload: *}}
 */


function setVehicleGroup(group) {
  return {
    type: _.SET_VEHICLE_GROUP,
    payload: group
  };
}
/**
 * Updates selected model
 *
 * @deprecated use setVehicleProgram() to set the vehicle model, use local state to set the currently selected model
 *
 * @param {string} model
 * @returns {function(*)}
 */


function setVehicleModel(model) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_VEHICLE_MODEL,
      payload: model
    });
  };
}
/**
 * Updates selected vehicle id
 *
 * @param {string} id
 * @returns {function(*)}
 */


function setVehicleId(id) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_VEHICLE_ID,
      payload: id
    });
  };
}

function setIndustryType(industryType) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_INDUSTRY_TYPE,
      payload: industryType
    });
  };
}
/**
 * Updates vehicle brand
 *
 * @param {string} brand of vehicle
 * @return {{type, payload: *}} action object
 */


function setVehicleBrand(brand) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_VEHICLE_BRAND,
      payload: brand
    });
  };
}
/**
 * Updates vehicle product type
 *
 * @param {string} productType of vehicle
 * @return {{type, payload: *}} action object
 */


function setVehicleProductType(productType) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_VEHICLE_PRODUCT_TYPE,
      payload: productType
    });
  };
}
/**
 * Updates vehicle product subtype
 *
 * @param {string} productSubtype of vehicle
 * @return {{type, payload: *}} action object
 */


function setVehicleProductSubtype(productSubtype) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_VEHICLE_PRODUCT_SUBTYPE,
      payload: productSubtype
    });
  };
}
/**
 * Sets vehicle program (year, model)
 *
 * @param {String} year
 * @param {String} model
 * @return {Function}
 */


function setVehicleProgram(year, model) {
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_VEHICLE_PROGRAM,
      payload: {
        year: year,
        model: model
      }
    });
  };
}

function setFilter(_ref) {
  var brand = _ref.brand,
      productType = _ref.productType;
  return function (dispatch) {
    dispatch({
      type: _.FLUSH_CONTENTS
    });
    dispatch({
      type: _.SET_FILTER,
      payload: {
        brand: brand,
        productType: productType
      }
    });
  };
}